var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPillFocusHypothesis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.79567 12C6.46522 12 6.18333 11.8825 5.95 11.6475C5.71667 11.4125 5.6 11.13 5.6 10.8V9.68333C4.96667 9.26889 4.475 8.7375 4.125 8.08917C3.775 7.44083 3.6 6.74444 3.6 6C3.6 4.77433 4.02656 3.73456 4.87967 2.88067C5.73278 2.02689 6.77167 1.6 7.99633 1.6C9.221 1.6 10.2611 2.02689 11.1167 2.88067C11.9722 3.73456 12.4 4.77433 12.4 6C12.4 6.74244 12.225 7.43917 11.875 8.09017C11.525 8.74117 11.0333 9.27222 10.4 9.68333V10.8C10.4 11.13 10.2823 11.4125 10.047 11.6475C9.81178 11.8825 9.52894 12 9.1985 12H6.79567ZM6.8 10.8H9.2V9.03333L9.75 8.68333C10.2056 8.39444 10.5611 8.01011 10.8167 7.53033C11.0722 7.05056 11.2 6.54044 11.2 6C11.2 5.11467 10.8876 4.36 10.2628 3.736C9.63817 3.112 8.88261 2.8 7.99617 2.8C7.10983 2.8 6.35556 3.112 5.73333 3.736C5.11111 4.36 4.8 5.11467 4.8 6C4.8 6.54044 4.92778 7.05056 5.18333 7.53033C5.43889 8.01011 5.79444 8.39444 6.25 8.68333L6.8 9.03333V10.8ZM6.8 14.4C6.57333 14.4 6.38333 14.3233 6.23 14.17C6.07667 14.0167 6 13.8267 6 13.6V13.2H10V13.6C10 13.8267 9.92333 14.0167 9.77 14.17C9.61667 14.3233 9.42667 14.4 9.2 14.4H6.8Z",
    fill: "#FC9015"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillFocusHypothesis);
export default __webpack_public_path__ + "static/media/pill_focus_hypothesis.17012f22ec31c75d7b7feb5e55f0d422.svg";
export { ForwardRef as ReactComponent };